var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcArrowRightGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3259 18.876L11.2009 3.1573C11.1483 3.11589 11.0851 3.09017 11.0186 3.08306C10.952 3.07596 10.8848 3.08777 10.8247 3.11714C10.7645 3.14652 10.7139 3.19225 10.6786 3.24911C10.6433 3.30596 10.6247 3.37162 10.625 3.43855V6.88944C10.625 7.10819 10.7277 7.31801 10.8973 7.45194L26.9688 20.001L10.8973 32.5502C10.7232 32.6841 10.625 32.8939 10.625 33.1127V36.5635C10.625 36.8627 10.9688 37.0278 11.2009 36.8448L31.3259 21.126C31.4969 20.9926 31.6353 20.8219 31.7305 20.627C31.8257 20.4321 31.8751 20.218 31.8751 20.001C31.8751 19.7841 31.8257 19.57 31.7305 19.3751C31.6353 19.1801 31.4969 19.0095 31.3259 18.876Z",
    fill: "#989BA0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcArrowRightGrey);
export default __webpack_public_path__ + "static/media/ic_arrow_right_grey.970c4794c77bf90b9fe2fdf564f16c7c.svg";
export { ForwardRef as ReactComponent };